/**
 * useFreshness — pretty-print "how old is this data?" in German.
 *
 * Usage: const fresh = useFreshness(iso); // → "vor 12 Min", "vor 2 Std"
 */
import { useEffect, useState } from "react";

function format(iso) {
  if (!iso) return "vor wenigen Augenblicken";
  let d;
  try { d = new Date(iso); } catch { return "kürzlich"; }
  const sec = Math.max(0, (Date.now() - d.getTime()) / 1000);
  if (sec < 60) return "gerade eben";
  if (sec < 3600) return `vor ${Math.round(sec / 60)} Min`;
  if (sec < 86400) return `vor ${Math.round(sec / 3600)} Std`;
  return `vor ${Math.round(sec / 86400)} Tg.`;
}

export function useFreshness(iso) {
  const [label, setLabel] = useState(() => format(iso));
  useEffect(() => {
    setLabel(format(iso));
    const id = setInterval(() => setLabel(format(iso)), 30000);
    return () => clearInterval(id);
  }, [iso]);
  return label;
}
